
    var riot = require('riot')
    
riot.tag2('resourcefilter', '<div class="bg-lightgrey padded padded-small"> <div class="container"> <div class="resfilter-grid"> <div each="{filt,i in filters}" class="filter"> <h4>{filt.title}</h4> <dropdown><a href="#" role="button" onclick="{toggle}" name="vistext">{filt.selected}<i class="fa fa-angle-down"></i></a> <ul class="dropdown-menu"> <li><a onclick="{parent.filterResources.bind(this,false,i)}">{filt.default}</a></li> <li each="{group in filt.list}" if="{filt.name == \'software\' || filt.name == \'application\'}"><span>{group.name}</span> <ul> <li each="{item,index in group.data}"><a onclick="{parent.parent.parent.filterResources.bind(this,item,i)}" class="{filt.selected == item ? \'active\' : \'\'}">{item}</a></li> </ul> </li> <li each="{item,index in filt.list}" if="{filt.name != \'software\' &amp;&amp; filt.name != \'application\'}"><a onclick="{parent.parent.filterResources.bind(this,item,i)}" class="{filt.selected == item ? \'active\' : \'\'}">{item}</a></li> </ul> </dropdown> </div> <div class="filter-button"> <button onclick="{searchResources}" class="form-control"><i class="fa fa-search"></i>Search</button> </div> </div> </div> </div> <div if="{resultcount == 0}" class="container"> <div class="row padded padded-top"> <div class="col-xs-12"> <h4>Sorry, your search returned no results</h4> </div> </div> </div>', '.resfilter-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)) 120px; grid-gap: 0 30px; -webkit-box-align: end; -moz-box-align: end; -o-box-align: end; -ms-flex-align: end; -webkit-align-items: end; align-items: end; } .resfilter-grid .filter-button button { border-radius: 0; border: 1px solid #d00; background: #d00; color: #fff; height: 40px; font-size: 17px; -webkit-transition: all ease 0.3s; -moz-transition: all ease 0.3s; -o-transition: all ease 0.3s; -ms-transition: all ease 0.3s; transition: all ease 0.3s; outline: 0px solid transparent; } .resfilter-grid .filter-button button:hover { background: #a00; border-color: #910000; } .resfilter-grid .filter-button button i.fa { padding-right: 5px; } .resfilter-grid .filter dropdown { position: relative; height: 40px; width: 100%; line-height: 40px; font-size: 17px; } .resfilter-grid .filter dropdown a { color: #292929; text-decoration: none; } .resfilter-grid .filter dropdown i.fa { position: absolute; right: 15px; top: 0; height: 40px; line-height: 40px; font-size: 22px; color: #d00; } .resfilter-grid .filter dropdown .dropdown-menu { width: 100%; left: 0; max-height: 200px; overflow-y: scroll; } .resfilter-grid .filter dropdown .dropdown-menu span { font-weight: bold; padding-left: 20px; padding-right: 20px; white-space: nowrap; -o-text-overflow: ellipsis; text-overflow: ellipsis; display: block; width: 100%; overflow: hidden; background: rgba(41,41,41,0.1); border-bottom: 1px solid rgba(0,0,0,0.1); border-top: 1px solid rgba(0,0,0,0.1); } .resfilter-grid .filter dropdown .dropdown-menu a { display: block; -webkit-transition: all ease 0.1s; -moz-transition: all ease 0.1s; -o-transition: all ease 0.1s; -ms-transition: all ease 0.1s; transition: all ease 0.1s; cursor: pointer; } .resfilter-grid .filter dropdown .dropdown-menu a.active { background: rgba(0,0,0,0.1); } .resfilter-grid .filter dropdown .dropdown-menu a:hover { background: #d00; color: #fff; } .resfilter-grid .filter dropdown .dropdown-menu ul { list-style: none; margin: 0; padding: 0; } .resfilter-grid .filter dropdown .dropdown-menu ul a { padding-left: 30px; } .resfilter-grid .filter dropdown a[name="vistext"] { -webkit-transition: all ease 0.8s; -moz-transition: all ease 0.8s; -o-transition: all ease 0.8s; -ms-transition: all ease 0.8s; transition: all ease 0.8s; display: block; padding: 0 40px 0 15px; height: 40px; width: 100%; max-width: 100%; overflow: hidden; white-space: nowrap; -o-text-overflow: ellipsis; text-overflow: ellipsis; background: #fff; border: 1px solid #999; } .resfilter-grid .filter dropdown a[name="vistext"].highlight { background: rgba(221,0,0,0.1); text-shadow: 0 0 2px rgba(221,0,0,0.5); } @media (max-width: 991px) { .resfilter-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-gap: 30px; } .resfilter-grid .filter-button { grid-column-start: 1; grid-column-end: 3; } } @media (max-width: 767px) { .resfilter-grid { grid-template-columns: minmax(0, 1fr); grid-gap: 15px; } .resfilter-grid .filter-button { grid-column-start: 1; grid-column-end: 2; } } .dl_resources .item.hideme { display: none; }', '', function(opts) {
this.dlist = document.querySelectorAll('.dl_resources .item');

this.resultcount = this.dlist.length;

this.resourcetypes = ["Brochure", "Demo Video", "Feature Story", "Magazine Article", "Overview Video", "Partner Case Study", "Partner News", "Partner White Paper", "Presentation", "Seminar Video", "Testimonial Video", "Webinar Video", "Wilde Case Study", "Wilde White Paper"];

this.industries = ["Aerospace", "Chemical and Process", "Defence", "Nuclear", "Oil & Gas", "Rail", "General"];

this.applications = ["Design for Reliability", "Asset Performance Management", "Functional Safety", "Human Factors Engineering", "Industry 4.0"];

this.applications = [
  {
    name: "Design for Reliability",
    data: ["FMEA / FMECA", "Life Data Analysis/Accelerated Life Testing", "System Reliability Modelling", "Standards Based Prediction", "Reliability Growth Analysis", "FRACAS/DRACAS"]
  }, {
    name: "Asset Performance Management",
    data: ["FMEA/FMECA", "Reliability Centred Maintenance", "System Reliability Modelling", "Logistics & Spares Modelling", "FRACAS/DRACAS", "Industry 4.0"]
  }, {
    name: "Functional Safety",
    data: ["Process Hazard Analysis", "SIL Assessment & Verification", "QRA & Consequence Analysis", "Root Cause Analysis", "Fault Tree Analysis", "Bow-Tie Analysis"]
  }, {
    name: "Human Factors Engineering",
    data: ["Alarm Management", "Control Room Design", "Human Factors Ergonomics", "Task and Human Error Analysis", "Environmental", "Incident Analysis"]
  }
];

this.software = [
  {
    name: "ReliaSoft Reliability Analysis",
    data: ["Weibull++", "Lambda Project", "BlockSim", "ALTA", "RGA", "RENO"]
  }, {
    name: "ReliaSoft Reliability Management",
    data: ["XFMEA", "RCM++", "XFRACAS", "MPC", "RBI", "Synthesis Enterprise Portal (SEP)"]
  }, {
    name: "ReliaSoft XFRACAS",
    data: ["ReliaSoft XFRACAS"]
  }, {
    name: "ANSYS",
    data: ["Ansys Sherlock", "Ansys medini analyze"]
  }, {
    name: "TECHNIS",
    data: ["FARADIP.FOUR", "BETAPLUS", "TTREE", "COMPARE", "ZONECHECK", "LOPA-PLUS"]
  }
];

this.filters = [
  {
    name: 'resourcetype',
    title: 'Resource Type',
    "default": 'All Resource Types',
    selected: 'All Resource Types',
    list: this.resourcetypes
  }, {
    name: 'industry',
    title: 'Industries',
    "default": 'All Industries',
    selected: 'All Industries',
    list: this.industries
  }, {
    name: 'application',
    title: 'Application',
    "default": 'All Applications',
    selected: 'All Applications',
    list: this.applications
  }, {
    name: 'software',
    title: 'Software',
    "default": 'All Software',
    selected: 'All Software',
    list: this.software
  }
];

this.filterlist = [];

this.on("mount", (function(_this) {
  return function() {
    return console.log("resource filter");
  };
})(this));

this.filterResources = (function(_this) {
  return function(str, index, e) {
    if (str && typeof str === "string") {
      _this.filters[index].selected = str;
    } else {
      _this.filters[index].selected = _this.filters[index]["default"];
    }
    _this.tags.dropdown[index].vistext.classList.add('highlight');
    setTimeout(function() {
      return _this.tags.dropdown[index].vistext.classList.remove('highlight');
    }, 1000);
    _this.filterlist = [];
    _this.filters.map(function(f) {
      if (f["default"] !== f.selected) {
        return _this.filterlist.push(f.selected);
      }
    });
    if (_this.filterlist.length === 0) {
      _this.resultcount = _this.dlist.length;
      [].map.call(_this.dlist, function(dl) {
        return dl.classList.remove('hideme');
      });
    }
    return _this.update();
  };
})(this);

this.searchResources = (function(_this) {
  return function() {
    if (_this.filterlist.length > 0 && _this.dlist.length > 0) {
      _this.resultcount = 0;
      [].map.call(_this.dlist, function(dl) {
        dl.classList.add('hideme');
        return _this.filterlist.map(function(fl) {
          fl = _this.escapeRegExp(fl);
          if (dl.getAttribute('data-tags').search(fl) > -1) {
            dl.classList.remove('hideme');
            return _this.resultcount++;
          }
        });
      });
    }
    return _this.update();
  };
})(this);

this.escapeRegExp = (function(_this) {
  return function(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  };
})(this);
});
riot.tag2('resource-tags', '<h4>Resource tags</h4> <div class="row"> <div each="{res in restags}" class="col-xs-12 col-sm-6 col-md-3"> <h4>{res.title}</h4> <div each="{dataval in res.data}" if="{res.title != \'Software\' &amp;&amp; res.title != \'Application\'}"> <input type="checkbox" value="{dataval}" onclick="{updateTags.bind(this,dataval)}" __checked="{checked.indexOf(dataval) &gt; -1}"> <label>{dataval}</label> </div> <div each="{group in res.data}" if="{res.title == \'Software\' || res.title == \'Application\'}"> <label>{group.name}</label> <div each="{dataval in group.data}" class="indent"> <input type="checkbox" value="{dataval}" onclick="{updateTags.bind(this,dataval)}" __checked="{checked.indexOf(dataval) &gt; -1}"> <label>{dataval}</label> </div> <hr> </div> </div> </div>', '.indent { padding-left: 10px; }', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/tags', true);

this.resourcetypes = ["Brochure", "Demo Video", "Feature Story", "Magazine Article", "Overview Video", "Partner Case Study", "Partner News", "Partner White Paper", "Presentation", "Seminar Video", "Testimonial Video", "Webinar Video", "Wilde Case Study", "Wilde White Paper"];

this.industries = ["Aerospace", "Chemical and Process", "Defence", "Nuclear", "Oil & Gas", "Rail", "General", "Electronics & Electrical"];

this.applications = [
  {
    name: "Design for Reliability",
    data: ["FMEA / FMECA", "Life Data Analysis/Accelerated Life Testing", "System Reliability Modelling", "Standards Based Prediction", "Reliability Growth Analysis", "FRACAS/DRACAS"]
  }, {
    name: "Asset Performance Management",
    data: ["FMEA/FMECA", "Reliability Centred Maintenance", "System Reliability Modelling", "Logistics & Spares Modelling", "FRACAS/DRACAS", "Industry 4.0"]
  }, {
    name: "Functional Safety",
    data: ["Process Hazard Analysis", "SIL Assessment & Verification", "QRA & Consequence Analysis", "Root Cause Analysis", "Fault Tree Analysis", "Bow-Tie Analysis"]
  }, {
    name: "Human Factors Engineering",
    data: ["Alarm Management", "Control Room Design", "Human Factors Ergonomics", "Task and Human Error Analysis", "Environmental", "Incident Analysis"]
  }
];

this.software = [
  {
    name: "ReliaSoft Reliability Analysis",
    data: ["Weibull++", "Lambda Project", "BlockSim", "ALTA", "RGA", "RENO"]
  }, {
    name: "ReliaSoft Reliability Management",
    data: ["XFMEA", "RCM++", "XFRACAS", "MPC", "RBI", "Synthesis Enterprise Portal (SEP)"]
  }, {
    name: "ReliaSoft XFRACAS",
    data: ["ReliaSoft XFRACAS"]
  }, {
    name: "ANSYS",
    data: ["Ansys Sherlock", "Ansys medini analyze"]
  }, {
    name: "TECHNIS",
    data: ["FARADIP.FOUR", "BETAPLUS", "TTREE", "COMPARE", "ZONECHECK", "LOPA-PLUS"]
  }
];

this.checked = [];

this.restags = [
  {
    title: "Resource Type",
    data: this.resourcetypes
  }, {
    title: "Industries",
    data: this.industries
  }, {
    title: "Application",
    data: this.applications
  }, {
    title: "Software",
    data: this.software
  }
];

this.on('mount', function() {
  return this.getCurrentTags();
});

this.updateTags = (function(_this) {
  return function(tagval, e) {
    var already, tagobj;
    if (!e.target.checked) {
      tagobj = _this.currentTags.filter(function(t) {
        return tagval === t.label;
      });
      if (tagobj[0]) {
        return _this.removeTag(tagobj[0]);
      }
    } else {
      already = (_this.currentTags.filter(function(t) {
        return t.label === tagval;
      })).length;
      if (already > 0) {
        return;
      }
      return _this.addTag(tagval);
    }
  };
})(this);

this.getCurrentTags = (function(_this) {
  return function() {
    return api.get({
      id: opts.page_id
    }, function(data) {
      _this.currentTags = data;
      _this.currentTags.map(function(t) {
        return _this.checked.push(t.label);
      });
      return _this.update();
    });
  };
})(this);

this.addTag = (function(_this) {
  return function(val) {
    var newTag;
    newTag = {
      page_id: opts.page_id,
      label: val
    };
    return api.save(newTag, function(data) {
      _this.currentTags.push(data);
      _this.checked.push(data.label);
      return _this.update();
    });
  };
})(this);

this.removeTag = (function(_this) {
  return function(tag) {
    return api.remove({
      id: tag.id
    }, function() {
      _this.currentTags = _this.currentTags.filter(function(t) {
        return tag.id !== t.id;
      });
      if (_this.checked.indexOf(tag.label) > -1) {
        _this.checked.splice(_this.checked.indexOf(tag.label), 1);
      }
      return _this.update();
    });
  };
})(this);
});
    
  